import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeTransferOrders'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeTransferOrdersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeTransferOrdersStore",
			variables: false,
		})
	}
}

export async function load_HomeTransferOrders(params) {
  await initClient()

	const store = new HomeTransferOrdersStore()

	await store.fetch(params)

	return {
		HomeTransferOrders: store,
	}
}
